<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  readonly docsHref?: string;
}
const props = withDefaults(defineProps<Props>(), {
  docsHref: 'https://github.com/const/tokenout/blob/main/.env.example',
});

const docsUrl = computed(() => props.docsHref);
</script>

<template>
  <div class="state-block" role="status">
    <div class="state-block__icon" aria-hidden="true">∅</div>
    <div class="state-block__title">未配置任何 provider</div>
    <div class="state-block__body">
      看起来服务端还没拿到任何一个平台的密钥。在
      <a
        :href="docsUrl"
        target="_blank"
        rel="noopener noreferrer"
      >.env.example</a>
      里填好后，重新部署或在 EdgeOne 控制台设置环境变量即可。
    </div>
  </div>
</template>
